import * as faker from 'faker';
import { optional } from '@library/common/functions';

import { ReportResponse } from './report-response';

export class MockReportResponse extends ReportResponse {
   constructor( schema?: any[] ) {
      super();

      if ( schema ) {
         schema.map( s => this.headers[s.name] = s?.header ?? s?.name );
      } else {
         // set headers
         Array.from(
            { length: ( faker.datatype.number( 10 ) + 1 )},
            _ => this.headers[ faker.random.word().toLowerCase() ] = faker.random.words()
         );
      }

      // create mock data
      this.collection = Array.from({ length: 10 }, _ => {
         const obj = {};
         Object.keys( this.headers ).map( h => {
            // obj[h] = faker.lorem.words();
            Object.assign( obj, {[ h ]: optional() ? faker.lorem.paragraphs( 30 ) : faker.lorem.words() });
         });

         return obj;
      });
   }
}
